import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TimeDisplayComponent } from './time-display.component';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { TimeDisplayMenuComponent } from './time-display-menu/time-display-menu.component';
import { TimeDisplayUtcComponent } from './time-display-utc/time-display-utc.component';

@NgModule({
    declarations: [TimeDisplayComponent, TimeDisplayMenuComponent, TimeDisplayUtcComponent],
    imports: [CommonModule, MatIconModule, MatMenuModule],
    exports: [TimeDisplayComponent, TimeDisplayUtcComponent],
})
export class TimeDisplayModule {}
